// this will eventually be replaced with useOpaqueIdentifier once it is stable:
// https://github.com/facebook/react/pull/17322
import { useRef } from 'react';
var idCounter = 1;
/**
 * Generates a unique id based on the provided prefix.
 * Be aware using the same prefix elsewhere _does not_ generate a unique id.
 * @param {string} prefix
 * @returns {string} unique prefixed id
 */

export function useId(prefix) {
  var id = useRef(null);

  if (id.current === null) {
    id.current = prefix + "-" + idCounter++;
  }

  return id.current;
}